export default "__VITE_ASSET__7hfZf$x1__"